import * as Yup from 'yup';

export const SubmissionSchema = Yup.object().shape({
  eSign: Yup.string()
    .max(25, 'Maximum 25 characters')
    .required('Please provide signature'),
  satisfactionLevel: Yup.number().min(1, 'Please provide rating').required(),
});
